import * as React from "react";
import { config } from "utils";
import { images } from "utils/config";
import { Button } from "components/elementsThemed";
import { Icon } from "components/elements";
import { Dropdown } from "components/fragments";
import css from "./NavDropdown.module.scss";

const profileIcon = config?.images?.icon_profile;
const logoutIcon = config?.images?.icon_logout;
const NavDropdown = ({
  children,
  buttonType,
  onClickProfile,
  onClickLogout,
}) => {
  return (
    <Dropdown className={css.dropdown} trigger={children}>
      <DropdownItem
        text="Profile"
        type={buttonType}
        icon={images?.icon_profile || profileIcon}
        onClick={onClickProfile}
      />
      <DropdownItem
        text="Logout"
        type={buttonType}
        icon={images?.icon_logout || logoutIcon}
        onClick={onClickLogout}
      />
    </Dropdown>
  );
};

const DropdownItem = ({ text, type, onClick, icon }) => (
  <Button className={css["dropdown-item"]} type={type} onClick={onClick}>
    {text}
    {icon && <Icon src={icon} />}
  </Button>
);

export default NavDropdown;
